import { makeAutoObservable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowDelegate, { QuoteFlowDomainParams } from 'store/flows/quote/quoteFlowDelegate';

export default class AddQuotePageStore {
  private _domainParams: QuoteFlowDomainParams;
  private _isActionLoading = false;
  public flowDelegate: QuoteFlowDelegate;

  public get isActionLoading(): boolean {
    return this._isActionLoading;
  }

  public get canCompleteStep(): boolean {
    return !this._isActionLoading && !this.flowDelegate.isInitialDataLoading;
  }

  private _setActionLoading(isLoading: boolean): void {
    this._isActionLoading = isLoading;
  }

  public async getInitialData(): Promise<void> {
    const cartId = this._domainParams.cartId;
    const cartModule = this.flowDelegate.cartModule;

    this.flowDelegate.setIsInitialDataLoading(true);

    await this.flowDelegate.getFlowInitialData();
    await cartModule.getCart(cartId);
    runInAction(() => {
      this.flowDelegate.setIsInitialDataLoading(false);
    });
  }

  // eslint-disable-next-line class-methods-use-this, no-empty-function
  public async onComplete(): Promise<void> {}

  constructor(params: QuoteFlowDomainParams) {
    this._domainParams = params;

    this.flowDelegate = new QuoteFlowDelegate({
      domainParams: params,
      nextPageId: QuoteRouteV2Id.QUOTE_CHECKLIST,
    });
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

const AddQuotePageStoreContext = createContext(new AddQuotePageStore({} as QuoteFlowDomainParams));

export const useAddQuotePageStore = (): AddQuotePageStore => {
  return useContext(AddQuotePageStoreContext);
};

export { AddQuotePageStore, AddQuotePageStoreContext };
